import React, { useState, useEffect } from 'react';
import Navbar from '../components/Navbar';
import { getChannels, addChannel, removeChannel, extractErrorMessage } from '../services/api';
import { FaHashtag, FaPlus, FaTrash } from 'react-icons/fa';
import { useToast } from '../components/Toast';
import '../styles/Channels.css';

function Channels({ user }) {
  const toast = useToast();
  const [channels, setChannels] = useState([]);
  const [loading, setLoading] = useState(true);
  const [newChannelId, setNewChannelId] = useState('');
  const [adding, setAdding] = useState(false);

  useEffect(() => {
    fetchChannels();
  }, []);

  const fetchChannels = async () => {
    try {
      setLoading(true);
      const data = await getChannels();
      setChannels(data);
    } catch (error) {
      console.error('Error fetching channels:', error);
      toast.error(extractErrorMessage(error, 'Kanäle konnten nicht geladen werden'));
    } finally {
      setLoading(false);
    }
  };

  const handleAdd = async (e) => {
    e.preventDefault();
    if (!newChannelId.trim() || adding) return;

    try {
      setAdding(true);
      await addChannel(newChannelId.trim());
      setNewChannelId('');
      toast.success('Kanal hinzugefügt');
      fetchChannels();
    } catch (error) {
      console.error('Error adding channel:', error);
      toast.error(extractErrorMessage(error, 'Fehler beim Hinzufügen des Kanals'));
    } finally {
      setAdding(false);
    }
  };

  const handleRemove = async (channelId) => {
    if (!window.confirm('Remove this channel from monitoring?')) return;

    try {
      await removeChannel(channelId);
      toast.success('Kanal entfernt');
      fetchChannels();
    } catch (error) {
      console.error('Error removing channel:', error);
      toast.error(extractErrorMessage(error, 'Fehler beim Entfernen des Kanals'));
    }
  };

  if (loading) {
    return (
      <div>
        <Navbar user={user} />
        <div className="loading-container">
          <div className="spinner"></div>
        </div>
      </div>
    );
  }

  return (
    <div className="app-layout">
      <Navbar user={user} />
      <main className="main-content">
        <div className="page-header">
          <h1>Watched Channels</h1>
          <p>Manage which Discord channels the bot monitors for links</p>
        </div>

        {user.isAdmin && (
          <div className="add-channel-form">
            <form onSubmit={handleAdd}>
              <div className="form-row">
                <FaHashtag className="input-icon" />
                <input
                  type="text"
                  placeholder="Enter Discord Channel ID"
                  value={newChannelId}
                  onChange={(e) => setNewChannelId(e.target.value)}
                  disabled={adding}
                />
                <button type="submit" disabled={adding || !newChannelId.trim()}>
                  <FaPlus /> Add Channel
                </button>
              </div>
            </form>
            <p className="form-hint">
              💡 Tip: Right-click a channel in Discord with Developer Mode enabled and select "Copy ID"
            </p>
          </div>
        )}

        <div className="channels-list">
          {channels.length > 0 ? (
            channels.map((channel) => (
              <div key={channel.id} className="channel-card">
                <div className="channel-info">
                  <FaHashtag className="channel-icon" />
                  <div className="channel-details">
                    <h3>{channel.channel_id}</h3>
                    <p>Added {new Date(channel.added_at).toLocaleDateString()}</p>
                  </div>
                </div>
                {user.isAdmin && (
                  <button
                    onClick={() => handleRemove(channel.channel_id)}
                    className="remove-btn"
                  >
                    <FaTrash />
                  </button>
                )}
              </div>
            ))
          ) : (
            <div className="no-channels">
              <FaHashtag size={64} />
              <h3>No Channels Configured</h3>
              <p>The bot is monitoring all channels by default.</p>
              {user.isAdmin && (
                <p>Add specific channel IDs above to restrict monitoring to those channels only.</p>
              )}
            </div>
          )}
        </div>
      </main>
    </div>
  );
}

export default Channels;
